export var lineStyleType;

(function (lineStyleType) {
  lineStyleType[lineStyleType["solid"] = 0] = "solid";
  lineStyleType[lineStyleType["dash"] = 1] = "dash";
})(lineStyleType || (lineStyleType = {}));

export var LinearDir;

(function (LinearDir) {
  LinearDir["VERTICAL"] = "vertical";
  LinearDir["HORIZONTAL"] = "horizontal";
})(LinearDir || (LinearDir = {}));

export var TextureBlend;
/**
 * 基础图层类型定义
 */

(function (TextureBlend) {
  TextureBlend["NORMAL"] = "normal";
  TextureBlend["REPLACE"] = "replace";
})(TextureBlend || (TextureBlend = {}));

export var SizeUnitType;

(function (SizeUnitType) {
  SizeUnitType[SizeUnitType["pixel"] = 0] = "pixel";
  SizeUnitType[SizeUnitType["meter"] = 1] = "meter";
})(SizeUnitType || (SizeUnitType = {}));

export var CanvasUpdateType;

(function (CanvasUpdateType) {
  CanvasUpdateType["ALWAYS"] = "always";
  CanvasUpdateType["DRAGEND"] = "dragend";
})(CanvasUpdateType || (CanvasUpdateType = {}));